<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.DESCRIPTION' | translate }}
  </div>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.ACTION.LIFECYCLE_STAGE"
    [dataService]="lifecycleStageSelectorService"
    [formControl]="lifecycleStageControl"
    [supportDataPassing]="false"
    [isRequired]="true"
    [multiple]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
</div>
